<template>
  <div class="content">
    <h1>Dag 1</h1>
    <p>I dag skal du lære:</p>
    <h2 style="margin: 6px 0;">Scratch/CodingLab</h2>
    <p>og</p>
    <h2 style="margin: 6px 0 24px 0;">Piskelapp</h2>

<hr>
    <h2>Scratch/CodingLab</h2>
    <p>
      Gå ind på CodingLab på <a href="https://www.skoletube.dk/" target="_blank">SkoleTube</a>
    </p>

    <p>
      Du næsten klar til at komme igang! <br />
      Du skal bare lige <b>ændre sprog til 'English'</b><br />
      Det gør man ved at klikke på globussen øverst til venstre i CodingLab <span style="display: inline-block; box-sizing: border-box; width: 27px; height: 27px; padding: 3px; background-color: hsla(215, 100%, 65%, 1);"><img src="/static/images/globe.svg"></span>
    </p>
    <img
      src="/static/images/learning/dag1/select_english.svg"
      alt="select english"
      style="width: 35%;"
    />

    <br />
    <br />
    <h3>Nu er du helt klar til at komme igang!</h3>
    <p>
      Følg vejledningerne i disse tre videoer, hvor du vil lære at lave dit eget
      spil. <br />
      Hav en fane åbent med videoerne og en fane hvor du koder dit spil. <br />
      Sæt videoerne på pause undervejs, imens du koder. <br />
      <br />
      <strong>
        Husk at gemme projektet undervejs!
      </strong>
    </p>


    <EmbedYoutube id="F_PmSvUpsQM" />
    <EmbedYoutube id="ZdGKkODDLkQ" />
    <EmbedYoutube id="EfM4262Ungg" />
    <h3>Nu har du lavet dit eget spil, og du har lært:</h3>
    <ul style="width: 400px; margin: 0 auto; text-align: left;">
      <li>At kode din karakter til at bevæge sig i alle retninger.</li>
      <li>At kode et objekt til at give dig point.</li>
      <li>At kode et objekt til at få dig til at miste liv.</li>
      <li>At lave og kode en game-over skærm.</li>
    </ul>


    <p style="font-weight: bold">
      Hvis du har lyst til at lave mere på dit spil kan du f.eks:
    </p>
    <ul style="width: 550px; margin: 0 auto; text-align: left;">
      <li>
        Lave og kode en vinder-skærm der kommer frem, når du har 50 point.
      </li>
      <li>
        Kode spillet så det skifter baggrund når du har 10, 20, 30 og 40 point.
      </li>
      <li>
        Kode en ond Boss der kommer frem når du har 15, 25 og 35 point,<br />og
        som skader 2 liv når den rammer dig.
      </li>
      <li>Tilføje andre ting til dit spil.</li>
    </ul>

  

    <p style="font-weight: bold">..Eller du kan starte på en ny video-tutorial! </p>
    
  <router-link class="purp" to="/video-tutorials" target="_blank" style="width: 150px;">Video Tutorials</router-link>
<br />
    <h2>PISKELAPP</h2>

    <h3>Nu skal du igang med at tegne!</h3>
    <p>
      Gå ind på
      <a href="https://www.piskelapp.com" target="_blank">piskelapp.com</a>
      <br />
      Følg vejledningerne i disse 2 videoer, hvor du vil lære at bruge
      tegneprogrammet Piskelapp. <br />
      Det er piskelapp du skal bruge til at tegne karaktererne til dit spil.
      <br />
      Sæt videoerne på pause undervejs, imens du tegner.
    </p>

    <EmbedYoutube id="K-KM1LXN104" title="Introduktion til PiskelApp" />
    <EmbedYoutube id="3kKwApVmHdg" title="Tegneværktøjer i PiskelApp" />
    <h3>Det var dagens lektioner, tak for i dag!</h3>
  </div>
</template>

<script>
import EmbedScratch from "@/components/ScratchEmbed";
import EmbedYoutube from "@/components/YoutubeEmbed";
export default {
  name: "Day1",
  components: {
    EmbedScratch,
    EmbedYoutube
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/undervisning/dag-1.vue